/* global window */

import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import tweenState from 'react-tween-state';
import Base from '@jimpick/spectacle/src/base';
import Transitions from './transitions';
import config from '@jimpick/spectacle/presentation/config';
import radium from 'radium';

const Slide = React.createClass({
  displayName: 'Slide',
  propTypes: {
    align: PropTypes.string,
    hash: PropTypes.string,
    presenterStyle: PropTypes.object,
    children: PropTypes.node,
    notes: PropTypes.string,
    slideIndex: PropTypes.number,
    lastSlide: PropTypes.number,
    finish: PropTypes.bool,
    teamNames: PropTypes.bool,
    missionReportQuestions: PropTypes.array
  },
  contextTypes: {
    styles: PropTypes.object,
    export: PropTypes.bool,
    print: PropTypes.bool,
    overview: PropTypes.bool,
    flux: PropTypes.object,
    slide: PropTypes.string,
    presenter: PropTypes.bool
  },
  mixins: [tweenState.Mixin, Base.Mixin, Transitions],
  getDefaultProps() {
    return {
      align: 'center center',
      presenterStyle: {}
    };
  },
  getInitialState() {
    return {
      zoom: 1,
      contentScale: 1
    };
  },
  componentDidMount() {
    this.setZoom();
    const slide = ReactDOM.findDOMNode(this.refs.slide);
    const frags = slide.querySelectorAll('.fragment');
    if (frags && frags.length) {
      Array.prototype.slice.call(frags, 0).forEach((frag, index) => {
        frag.dataset.fid = index;
        this.context.flux.actions.SlideActions.addFragment({
          slide: this.props.hash,
          id: index,
          visible: this.props.lastSlide > this.props.slideIndex
        });
      });
    }
    window.addEventListener('load', this.setZoom);
    window.addEventListener('resize', this.setZoom);
  },
  componentWillUnmount() {
    window.removeEventListener('resize', this.setZoom);
  },
  setZoom() {
    // const mobile = window.matchMedia('(max-width: 628px)').matches;
    const content = ReactDOM.findDOMNode(this.refs.content);
    const zoom = (content.offsetWidth / config.width);
    const contentScaleY = (content.parentNode.offsetHeight / config.height);
    const contentScaleX = (content.parentNode.offsetWidth / config.width);
    const contentScale = Math.min(contentScaleY, contentScaleX);
    this.setState({
      zoom: zoom > 0.6 ? zoom : 0.6,
      contentScale: contentScale < 1 ? contentScale : 1
    });
  },
  render() {
    const printStyles = this.context.print ? {
      backgroundColor: 'white',
      backgroundImage: 'none'
    } : {};
    const overViewStyles = {
      inner: {
        flexDirection: 'column'
      },
      content: {
        width: '100%'
      }
    };
    const styles = {
      outer: {
        position: this.context.export ? 'relative' : 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        backgroundColor: this.context.styles.global.body.background ?
          this.context.styles.global.body.background : ''
      },
      inner: {
        display: 'flex',
        position: 'relative',
        height: '100%',
        flex: 1,
        alignItems: this.props.align ? this.props.align.split(' ')[1] : 'center',
        justifyContent: this.props.align ? this.props.align.split(' ')[0] : 'center'
      },
      content: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%',
        // maxHeight: config.height,
        // maxWidth: config.width,
        fontSize: 16 * this.state.zoom
        // transform: 'scale(' + this.state.contentScale + ')',
        // padding: this.state.zoom > 0.6 ? config.margin : 10
        // padding: '60px 40px 40px'
      }
    };
    if (this.context.presenter) {
      styles.content.transform = 'scale(' + this.state.contentScale + ')';
    }
    return (
      <div className="spectacle-slide"
        ref="slide"
        style={[
          styles.outer,
          this.getStyles(),
          this.getTransitionStyles(),
          printStyles,
          this.props.presenterStyle]}>
        <div style={[styles.inner, this.context.overview && overViewStyles.inner]}>
          <div ref="content"
            className="spectacle-content"
            style={[styles.content, this.context.styles.components.content, this.context.overview && overViewStyles.content]}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
});

export default radium(Slide);



// WEBPACK FOOTER //
// ./src/views/session/presentation/spectacle-ppa/src/slide.jsx